import React from 'react'
import { FaPencilAlt } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type EditControlProps = {
  openObjectDetails: () => void
  isCreating: boolean
  isEditing: boolean
  control: string
}

const EditControl = ({ openObjectDetails, isCreating, isEditing, control }: EditControlProps) => {
  const handleClick = () => {
    if (isCreating || isEditing) {
      return
    }
    openObjectDetails()
  }

  return (
    <div className={cn('control', 'edit')} data-graph-type="control" title={`Edit ${control}`}>
      <a className={cn('icon', { disabled: isCreating || isEditing })} onClick={handleClick}>
        <FaPencilAlt aria-hidden />
        <span className="sr-only">Edit</span>
      </a>
    </div>
  )
}

export default EditControl
